var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('click')}}},[_c('FontAwesomeIcon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }